import { render, staticRenderFns } from "./login_page.vue?vue&type=template&id=0c052f5c&scoped=true"
import script from "./login_page.vue?vue&type=script&lang=js"
export * from "./login_page.vue?vue&type=script&lang=js"
import style0 from "./login_page.vue?vue&type=style&index=0&id=0c052f5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c052f5c",
  null
  
)

export default component.exports